import { Icon } from '@fattureincloud/fic-design-system'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'
import React, { FC, Fragment, useState } from 'react'

import { LinkButton } from '../../layout_components/LinkButton'
import { locale } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import { Path } from '../definitions'
import HelpAutocomplete from '../HelpAutocomplete/HelpAutocomplete'
import { BreadCrumbsImp, BreadCrumbsText } from './breadcrumbs.components'

interface Props {
  className: string
  embedded: boolean
  onSelect: (permalink: string, key: string) => void
  paths: Path[]
  isExternal: boolean
}

const BreadCrumbs: FC<Props> = (props: Props) => {
  const [shadow, setShadow] = useState<boolean>(false)
  const editorModeActive = useAppSelector((state) => state.editor.value)
  const handleOpen = (value: boolean) => {
    setShadow(value)
  }

  return (
    <BreadCrumbsImp
      shadow={shadow}
      className={props.className}
      embedded={props.embedded}
    >
      <div
        className={`breadContainer ${
          props.embedded ? 'embeddedbreadCrumbs' : ''
        }`}
      >
        <BreadCrumbsText>
          <LinkButton
            text={locale('Supporto clienti')}
            onClick={() => props.onSelect(undefined, 'main')}
          />
          <Icon icon={faAngleRight} />
          {props.paths.map((path, idx) => {
            const text = (editorModeActive ? `${path.id} - ` : '') + path.text
            return (
              <Fragment key={idx}>
                {path.onClick ? (
                  <LinkButton text={text} onClick={() => path.onClick()} />
                ) : (
                  <span style={{ fontWeight: 600 }}>{text}</span>
                )}
                {idx < props.paths.length - 1 && <Icon icon={faAngleRight} />}
              </Fragment>
            )
          })}
        </BreadCrumbsText>
        <HelpAutocomplete
          internal
          onSelect={props.onSelect}
          onOpen={handleOpen}
          className='autocomplete'
          isExternal={props.isExternal}
        />
      </div>
    </BreadCrumbsImp>
  )
}

export default BreadCrumbs
